// services/celebration.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import confetti from 'canvas-confetti';

@Injectable({
  providedIn: 'root'
})
export class CelebrationService {
  
  private celebrationSubject = new Subject<boolean>();
  celebration$ = this.celebrationSubject.asObservable();

  triggerCelebration(): void {
    this.celebrationSubject.next(true);

    // Confetti burst
    const duration = 3 * 1000;
    const end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 7,
        startVelocity: 30,
        spread: 360,
        origin: {
          y: 0.6,
          x: Math.random()
        }
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();

    // Auto hide after 4 seconds
    setTimeout(() => {
      this.celebrationSubject.next(false);
    }, 4000);
  }

  // Different celebration styles
  triggerFireworks(): void {
    confetti({
      particleCount: 150,
      spread: 100,
      origin: { y: 0.6 }
    });
  }

  triggerSideConfetti(): void {
    confetti({
      particleCount: 50,
      angle: 60,
      spread: 55,
      origin: { x: 0 }
    });
    confetti({
      particleCount: 50,
      angle: 120,
      spread: 55,
      origin: { x: 1 }
    });
  }

  triggerCustomConfetti(originY: number = 0.6): void {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: originY }
    });
  }
}